<template>
  <div>
    <headers/>
      <van-overlay @click='kapat' :show="$store.getters.getLoading[0]">
        <div class="wrapper">
          <van-loading size="32px" color="#fff" type="spinner" vertical>{{$store.getters.getLoading[1]}}</van-loading>
        </div>
      </van-overlay>

      <router-view/>

      <!-- <div style="height:70px"></div>

        <van-tabbar style="background:none !important">
          <van-tabbar-item name="Home" to="/home" icon="wap-home-o">Homes</van-tabbar-item>
          <van-tabbar-item name="Servis" to="/stok" icon="apps-o">Ürün</van-tabbar-item>
          <van-tabbar-item name="Sepet" to="/cari" icon="cluster-o">Kurum</van-tabbar-item>
          <van-tabbar-item name="Depom" to="/satis" icon="todo-list-o">Uygulama</van-tabbar-item>
          <van-tabbar-item name="Cihaz" to="/sepet" icon="bag-o">Liste</van-tabbar-item>
          <van-tabbar-item name="Depo sevk" to="/deposevk" icon="logistics">Sevk</van-tabbar-item>
          <van-tabbar-item name="Hesabım" to="/uygulamalar" icon="manager-o">Hesap</van-tabbar-item>
        </van-tabbar> -->
        <footers/>

  </div>
</template>

<script>
import { decode } from 'js-base64';
import headers from '@/components/headers';
import footers from '@/components/footers';



export default {
  components:{
    headers,footers
  },
  name: 'app',
    data() {
      return {
            // fad:decode(this.$request.ayar().genel.f),
            // isim:decode(this.$request.ayar().genel.k),
      };
  },
  created(){
    //this.active = this.$route.name
    //alert("drg")
  },
  methods: {

    kapat(){
      this.$store.commit("setLoading",[false,'...'])
    }
      // cikis(){
      //     this.$helper.logout();
      // },    
  }  
 
}
</script>
<style>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  .van-icon-arrow-left{
    color:white !important;
    font-size: 32px;
  }
  .van-cell__title{
    font-size:14px !important;
    margin-left:0px !important
  }
</style>


// WEBPACK FOOTER //
// src/components/content.vue